<template>
  <v-app>
    <v-navigation-drawer
      persistent
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      dark
      color="primary"
    >
      <div>
      </div>
      <v-list v-if="authUser.isLoggedIn">
        <v-list-item link :to="{name: 'serverLogs'}">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title id="home-menu">Server Logs</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="{name: 'models'}">
          <v-list-item-icon>
            <v-icon>mdi-file-chart</v-icon>
          </v-list-item-icon>
          <v-list-item-title id="model-report-menu">Model Logs</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="NoiseGrasp Logo"
          class="shrink mr-2"
          contain
          :src="require('./assets/header_logo.png')"
          transition="scale-transition"
          width="160"
        />
      </div>

      <v-spacer></v-spacer>

      <v-btn
      v-if="!authUser.isLoggedIn"
        text
        @click="signIn"
      >
        <span class="mr-2">Login with Google</span>
        <v-icon>mdi-login</v-icon>
      </v-btn>
      <v-btn
      v-else
        text
      >
        <span class="mr-2">{{ authUser.email }}</span>
        <v-icon @click="logout">mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main v-if="authUser.isLoggedIn">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  data: () => ({
    firebaseUser: null,
    drawer: null
  }),

  methods: {
    ...mapActions('auth', [
      'initAuth',
      'signIn',
      'signOut'
    ]),
    logout () {
      /* firebase.auth().signOut().then(() => {
        this.firebaseUser = null
      }) */
      this.signOut()
    }
  },
  computed: {
    ...mapGetters('auth', [
      'authUser'
    ])
  },
  mounted: function () {
    this.initAuth().then(() => {
      //console.log(`Initialized. User: ${JSON.stringify(user)}`)
      console.log('Initialized user.')
    })
  }
}
</script>
